const COOPERATION_AND_ASSOCIATION = [
  "国際協力共済会",
  "International Cooperation and Mutual Aid Association",
]

export const Constants = { COOPERATION_AND_ASSOCIATION }
